import { fr } from 'date-fns/locale';
import { i18n, SUPPORTED_LOCALES, DEFAULT_LOCALE } from '@/i18n';

// date-fns ships English as its built-in default, so only non-English locales
// are mapped here. The values must be static imports (deriving them from
// SUPPORTED_LOCALES would require importing every date-fns locale and defeat
// tree-shaking), so add one import + entry when adding a locale.
const dateFnsLocales = { fr };

if (import.meta.env.DEV) {
  const unmapped = SUPPORTED_LOCALES.filter(
    (code) => code !== DEFAULT_LOCALE && !dateFnsLocales[code]
  );
  if (unmapped.length) {
    console.warn(`[i18n] SUPPORTED_LOCALES missing date-fns mapping (dates will render in English): ${unmapped.join(', ')}`);
  }
}

// Resolves the date-fns locale object for the active vue-i18n locale.
// Returns undefined for English (date-fns default).
export function dateFnsLocale() {
  return dateFnsLocales[i18n?.global.locale.value];
}
